exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sk-spinner{color:#333}.sk-spinner>div{background-color:currentColor}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/react-spinkit/css/base.css
// module id = 763
// module chunks = 0